import { Lightbulb, Compass, Rocket } from "lucide-react";

const cards = [
  {
    icon: Lightbulb,
    title: "Clarifiez votre projet",
    desc: "Identifiez vos forces, valeurs et aspirations profondes",
  },
  {
    icon: Compass,
    title: "Explorez vos options",
    desc: "Reconversion, évolution, création d'entreprise… trouvez votre voie",
  },
  {
    icon: Rocket,
    title: "Passez à l'action",
    desc: "Repartez avec un plan concret et actionnable",
  },
];

const WhatIsSection = () => {
  const scrollToForm = () => {
    document.getElementById("hero-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto text-center">
        <h2 className="mb-4 text-3xl font-extrabold md:text-4xl">
          Le Bilan de Compétences : Votre Tremplin vers une Carrière qui Vous Ressemble
        </h2>
        <p className="mx-auto mb-12 max-w-2xl text-muted-foreground">
          Un accompagnement sur-mesure pour reprendre le contrôle de votre parcours professionnel.
        </p>
        <div className="grid gap-8 md:grid-cols-3">
          {cards.map((c) => (
            <div
              key={c.title}
              className="group rounded-2xl border border-border bg-card p-8 text-center shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-xl bg-secondary text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <c.icon className="h-7 w-7" />
              </div>
              <h3 className="mb-2 text-xl font-bold">{c.title}</h3>
              <p className="text-muted-foreground">{c.desc}</p>
            </div>
          ))}
        </div>
        <button onClick={scrollToForm} className="btn-cta-sm mt-10">
          Je commence mon bilan dès maintenant →
        </button>
      </div>
    </section>
  );
};

export default WhatIsSection;
